// extracted by mini-css-extract-plugin
export default {"countdownSection":"CountdownSection_countdownSection__VVj2o","layer2":"CountdownSection_layer2__OQP9p","countdownWrapper":"CountdownSection_countdownWrapper__84Mol"};